export const LOCATIONS_URL = '/locations';
export const COUNTRIES_URL = '/countries';
export const RECEIPTS_URL = '/receipts';
